import React, { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import useSeamlessLogin from '@/hooks/useSeamlessLogin';
import { requestCheckoutSession } from '@/utils/utils';
import LoaderIcon from '@/images/icons/Loader';

export default function Join() {
	const [searchParams] = useSearchParams();

	const navigate = useNavigate();
	const location = useLocation();
	const {
		telegramUser,
		loggedIn,
	} = useSeamlessLogin();

	const onRequestCheckoutSession = async (name, yearly) => {
		let toRedirect = false;

		try {
			const response = await requestCheckoutSession({
				endpoint: `${process.env.REACT_APP_API_URL}/stripeCheckoutSession`,
				name: name,
				isYearly: yearly,
				region: 'CY',
				telegramUser,
			});

			if (response.ok && response.status === 200) {
				const responseData = await response.json();

				if (responseData.sessionId) {
					let stripePublicKey = responseData.stripePublicKey || process.env.REACT_APP_STRIPE_KEY;
					const stripe = await loadStripe(stripePublicKey);

					if (stripe) {
						const result = await stripe.redirectToCheckout({
							sessionId: responseData.sessionId,
						});

						if (result.error) {
							console.log(`Stripe: ${result.error.message}`);
							toRedirect = true;
						}
					} else {
						console.log("There was an issue processing your payment. Please try again later.");
						toRedirect = true;
					}
				} else {
					toRedirect = true;
				}
			}
		} catch (error) {
			console.log(error);
			toRedirect = true;
		}

		if (toRedirect) {
			navigate('/manage-subscription');
		}
	};

	useEffect(() => {
		if (searchParams.get('plan')) {
			if (loggedIn) {
				onRequestCheckoutSession(searchParams.get('plan'), searchParams.get('billed') === 'yearly');
			} else {
				const redirectUrl = encodeURIComponent(location.pathname + location.search);
				navigate(`/signup?redirectUrl=${redirectUrl}`, { replace: true });
			}
		} else {
			navigate('/manage-subscription');
		}
	}, [loggedIn, searchParams]);

	return (
		<div className="flex items-center justify-center py-1 pointer-events-none h-screen w-full">
			<LoaderIcon className="animate-rotation w-12 h-12 text-brand-green" />
		</div>
	);
}
